import "./header.css"
import campaign from "../../assets/campaign.svg"
// import arrow from "../../assets/Arrow 3.svg";
const HeaderUpper = () => {
  return (
    <section className="header-upper">
      <div className="container">
      <div className="header-upper-wrapper">
        <div className="header-text">
          <img src={campaign} alt="campaign-icon" />
          <p>Meet Observability 3.0 for Enterprises #2026</p>
        </div>
        {/* <div className="header-upper-cta">
          <a href="">
            <p>Learn More</p>
          </a>
          <img src={arrow} alt="arrow-icon" />
        </div> */}
      </div>
      </div>
    </section>
  );
};

export default HeaderUpper;
